// Third-party Imports
import { PLATFORM, platformTitle } from '@coresoft/platform-contract'

/**
 * Names and copy for this deployment. Identity (name, version, copyright) is NOT
 * restated here — it comes from @coresoft/platform-contract, which the API reads
 * from too, so a version bump is one edit in one file.
 */
export const siteConfig = {
  name: PLATFORM.name,
  title: platformTitle(),
  shortName: 'Coresoft',
  description: PLATFORM.description,
  version: PLATFORM.version,
  displayVersion: PLATFORM.displayVersion,
  copyright: PLATFORM.copyright,
  vendor: PLATFORM.vendor,
  vendorUrl: PLATFORM.vendorUrl,

  /** Link-preview card, 1200x630. Rebrand by replacing the file at this path. */
  ogImage: '/images/og-image.jpg',

  /*
   * A workspace is a display-level tenant only — it carries no permissions. Access
   * is decided entirely by the roles the API grants; see the RBAC schema in apps/api.
   */
  workspaces: [{ id: 'ws_coresoft', name: 'Coresoft', plan: platformTitle(), logo: '', mark: 'brand' }]
} as const
